const handleApiErrors = function (apiResponse) {
  if (!apiResponse.ok) {
    console.error('handling API errors', apiResponse)
    throw Error(apiResponse.statusText)
  }
  return apiResponse
}

export { handleApiErrors }
